import { Component, OnDestroy, OnInit, TemplateRef, Optional } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

import { DialogConfig, DialogController } from './dialog-controller';

@Component({
  selector: 'ui-dialog',
  templateUrl: './dialog.component.html'
})

export class DialogComponent implements OnInit, OnDestroy {
  show: boolean = false;

  title: string | TemplateRef<any> = '';
  content: string | TemplateRef<any> = '';
  btnsText: Array<any> = ['åæ¶', 'ç¡®è®¤'];
  result: boolean = false;

  get titleIsString() {
    return typeof this.title === 'string';
  }

  get contentIsString() {
    return typeof this.content === 'string';
  }

  private subs: Subscription[] = [];

  constructor(private dialogController: DialogController,
              @Optional() private router: Router) {
  }

  ngOnInit() {
    if (this.router) {
      this.subs.push(this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.show = false;
        }
      }));
    }
    // è®¢éç¨æ·äºä»¶
    this.subs.push(this.dialogController.config.subscribe((params: DialogConfig) => {
      // è®¾ç½®å¨ç»ç¶æ
      this.show = true;

      // èµå¼ç¸åºåæ°
      this.title = params.title;
      this.content = params.content;
      if (params.btnsText) {
        this.btnsText = params.btnsText;
      }
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }

  checked(result: boolean) {
    // å½ç¨æ·ç¹å»ææ­æ¶ï¼å³é­å¼¹çª
    this.show = false;
    this.result = result;
  }

  hide() {
    // å½å¼¹çªå³é­å¨ç»å®ææ¶ï¼åå¸ç¸åºäºä»¶
    this.dialogController.publishAction(this.result);
  }
}